
export type GetTrendingHashtags200HashtagsItem = {
  id?: string;
  name?: string;
  tweetCount?: number;
};
